import _ from 'lodash';
import classNames from 'classnames';
import objectAssign from 'object-assign';
import React, { PropTypes } from 'react';
import FontAwesome from 'react-fontawesome';
// import SelectInput from '../../../components/common/SelectInput';
import { DragSource } from 'react-dnd';
import Select from 'react-select';
import moment from 'moment-timezone';
import 'moment/locale/nb';

const memberSource = {
  // canDrag(props) {
  //   // You can disallow drag based on props
  //   return props.isReady;
  // },
  //
  // isDragging(props, monitor) {
  //   // If your component gets unmounted while dragged
  //   // (like a card in Kanban board dragged between lists)
  //   // you can implement something like this to keep its
  //   // appearance dragged:
  //   return monitor.getItem().id === props.id;
  // },

  // beginDrag(props /*, monitor, component*/) {
  //   // Return the data describing the dragged item
  //   const item = props.member.member_reg_details;
  //   return {items: [item]};
  // },

  beginDrag(props) { // monitor, component
    // Return the data describing the dragged item
    const item = props.member.member_reg_details;
    const selectedMembers = props.selectedMembers;
    if (_.size(selectedMembers) > 1) {
      return {items: selectedMembers};
    } else {
      return {items: [item]};
    }
  },

  endDrag(props, monitor /*, component */) {
    const dropResult = monitor.getDropResult();
    //   console.log(monitor.getDropResult());
    // if (!monitor.didDrop()) {
    //   if (_.size(props.selectedMembers) > 1) {
    //     props.selectedMembers.forEach((member) => {
    //         props.removeMemberRegFromTeam(member);
    //     })
    //   } else {
    //     props.removeMemberRegFromTeam(props.member.member_reg_details);
    //   }
    //   // You can check whether the drop was successful
    //   // or if the drag ended but nobody handled the drop
    //   return true;
    // } else if (!monitor.didDrop() && !dropResult) {
    //   return true;
    // }
    if (!dropResult) {
      return true;
    }

    // When dropped on a compatible target, do something.
    // Read the original dragged item from getItem():
    // const item = monitor.getItem();

    // You may also read the drop result from the drop target
    // that handled the drop, if it returned an object from
    // its drop() method.
    if (props.team.identifier != dropResult.details.identifier) {
      if (_.size(props.selectedMembers) > 1) {
        props.selectedMembers.forEach((member) => {
            props.removeMemberRegFromTeam(member);
        })
      } else {
        props.removeMemberRegFromTeam(props.member.member_reg_details);
      }
    }
    props.clearSelected();
    // console.log(dropResult);
    // This is a good place to call some Flux action
    // CardActions.moveCardToList(item.id, dropResult.listId);
  }

};

function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    // You can ask the monitor about the current drag state:
    isDragging: monitor.isDragging(),
  };
}

class TeamMember extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.updateField = this.updateField.bind(this);
    this.checkDate = this.checkDate.bind(this);
    this.checkAge = this.checkAge.bind(this);
    this.checkMemberRestrictions = this.checkMemberRestrictions.bind(this);
    this.renderCategoryDiff = this.renderCategoryDiff.bind(this);
    this.showDragHandle = this.showDragHandle.bind(this);
    this.removeSelectedMembers = this.removeSelectedMembers.bind(this);
    this.renderDeleteBtn = this.renderDeleteBtn.bind(this);
  }

  updateField(event) {
    let member = objectAssign({}, this.props.member);
    member[event.target.name] = event.target.value;
    this.props.updateTeamMember(member);
  }

  updateMultiSelect(values, target) {
    let value;
    if (values && values.value) {
      value = [values.value];
    } else {
      value = _.map(values, 'value');
    }
    let member = objectAssign({}, this.props.member);
    member[target] = value;
    this.props.updateTeamMember(member);
  }

  checkDate(before, after) {
    if (before && after) {
      return Date.parse(before) >= Date.parse(after);
    } else {
      return true;
    }
  }

  checkAge(minAge, maxAge) {
    let birthday = this.props.member.member_reg_details.member_details.birth_date;
    let bellowMaxAge = this.checkDate(birthday, maxAge);
    let aboveMinAge = this.checkDate(minAge, birthday);
    if (!aboveMinAge) {
      return 'Deltageren er for ung (Født: ' + moment.tz(birthday, 'Europe/Oslo').format('DD.MM.YYYY') +
      '). Deltageren må være født før ' +
      moment.tz(minAge, 'Europe/Oslo').format('DD.MM.YYYY');
    } else if (!bellowMaxAge) {
      return 'Deltageren er for gammel (Født: ' + moment.tz(birthday, 'Europe/Oslo').format('DD.MM.YYYY') +
      '). Deltageren må være født etter ' +
      moment.tz(maxAge, 'Europe/Oslo').format('DD.MM.YYYY');
    } else {
      return false;
    }
  }

  checkMemberRestrictions(cat) {
    let birthday = this.props.member.member_reg_details.member_details.birth_date;
    let bellowMaxAge = this.checkDate(birthday, cat.max_birthdate);
    let aboveMinAge = this.checkDate(cat.min_birthdate, birthday);
    let categoryCount = this.props.usedMemberCategories[cat.id] || 0;
    let maxCategory = cat.max_of_category && (cat.max_of_category <= categoryCount);
    let aboveMaxCategory = cat.max_of_category && (cat.max_of_category < categoryCount);
    let minCategory = cat.min_of_category && (cat.min_of_category > categoryCount);
    let name = cat.name;
    let classname = 'bg-success';
    let disabled = false;

    if (aboveMinAge && bellowMaxAge && minCategory) {
      name += ' (Minst: ' + cat.min_of_category + ')';
      classname = 'bg-warning';
    }

    if (maxCategory) {
      name += ' (Maks: ' + cat.max_of_category + ')';
      disabled = true;
      classname = aboveMaxCategory ? 'bg-danger' : 'bg-success';
    }
    if (!aboveMinAge) {
      classname = 'bg-danger';
      disabled = true;
      name += ' (for ung)';
    }
    if(!bellowMaxAge) {
      classname = 'bg-danger';
      disabled = true;
      name += ' (for gammel)';
    }
    return {name, classname, disabled};
  }

  renderCategoryDiff() {
    let deleted = [];
    let added = [];
    _(this.props.memberDiff.categories).forEach((item) => {
      let itemName = _.find(this.props.memberCategories, {id: item[0]});
      if (!itemName) {
        return null;
      }
      if (item[1] === 0 && item[2] === 0) {
        deleted.push(itemName.name);
      } else if(typeof item != 'string' &&
          item[1] === undefined &&
          item[2] === undefined &&
          item[0] !== undefined) {
        added.push(itemName.name);
      }
    });
    return {
      deleted,
      added,
      allChanged: [...deleted, ...added]
    };
  }

  showDragHandle(selected) {
    let size = _.size(this.props.selectedMembers);
    if (size == 0 || selected) {
      return this.props.connectDragSource(
        <span
          onClick={(e) => {e.preventDefault(); e.stopPropagation();}}
          className="btn btn-default btn-sm btn-drag">
          <FontAwesome name="bars" />
          {' Dra '}
          {(_.size(this.props.selectedMembers) != 0) &&
            <span className="label label-default">
              {_.size(this.props.selectedMembers)}
            </span>
          }
        </span>
      );
    } else {
      return (
        <span
          onClick={(e) => {e.preventDefault(); e.stopPropagation();}}
          className="btn btn-default btn-sm disabled pull-right">
          {'Ikke valgt'}
        </span>
      );
    }
  }

  removeSelectedMembers() {
    if (_.size(this.props.selectedMembers) > 0) {
      this.props.removeMemberRegFromTeam(this.props.selectedMembers);
    } else {
      this.props.removeMemberRegFromTeam(this.props.member.member_reg_details);
    }
    this.props.clearSelected();
  }

  renderDeleteBtn() {
    if (!this.props.disabled && (this.props.selected || this.props.selectedMembers == 0)) {
      return (
        <a className="btn btn-danger btn-sm"
          onClick={() => {
            this.removeSelectedMembers();
          }}>
          <FontAwesome name="trash" />
        </a>
      )
    } else {
      return (
        <a className="btn btn-default disabled btn-sm"
          onClick={() => {
            this.removeSelectedMembers();
          }}>
          <FontAwesome name="trash" />
        </a>
      )
    }
  }

  render () {
    let oneOrMore = true;
    if (this.props.teamCategory.require_member_category) {
      oneOrMore = this.props.member.categories.length > 1;
    }

    let categoryOptions = this.props.memberCategories.map((cat) => {
      let {name, classname, disabled} = this.checkMemberRestrictions(cat);
      return {
        value: cat.id,
        label: name,
        className: classname,
        disabled: disabled,
        clearableValue: oneOrMore,
      };
    });
    let multi = this.props.teamCategory.allow_multiple_member_categories;
    let value = this.props.member.categories;
    if (multi == false) {
      value = value[0];
    }
    let minAge = this.props.teamCategory.min_birthdate;
    let maxAge = this.props.teamCategory.max_birthdate;
    let ageText = this.checkAge(minAge, maxAge);
    let emptyClass = '';
    if (this.props.teamCategory.require_member_category &&
        _.isEmpty(this.props.member.categories)) {
      emptyClass = 'error-select-input';
    }

    let member_details = this.props.member.member_reg_details.member_details;
    return this.props.connectDragPreview(
      <div key={this.props.member.id}
        className={classNames("list-group-item member-list clearfix",{
          'item-disabled': this.props.disabled,
        })}>
        {this.props.diffStatus['deleted'] && <span>
          <FontAwesome name="minus-square" className="text-danger" />
          &emsp;
        </span>}
        {this.props.diffStatus['changed'] && <span>
          <FontAwesome name="warning" className="text-warning" />
          &emsp;
        </span>}
        {this.props.diffStatus['added'] && <span>
          <FontAwesome name="plus-square" className="text-success" />
          &emsp;
        </span>}
        <label htmlFor={'check_' + this.props.member.identifier}>
          <strong className="member-name">
            <input
              onChange={() => {
                if (!this.props.disabled) {
                  this.props.addToSelected(this.props.member.member_reg_details);
                }
              }}
              disabled={this.props.disabled}
              type="checkbox"
              checked={this.props.selected}
              id={'check_' + this.props.member.identifier}/>
            &nbsp;
            {member_details.first_name +
              ' ' +
              member_details.last_name}
          </strong>
          <span className="text-muted">
            {' - '}
            {moment.tz(member_details.birth_date,
              'Europe/Oslo').format("DD.MM.YYYY")}
          </span>
        </label>
        <span className="pull-right">
          {this.renderDeleteBtn()}
          &nbsp;
          {!this.props.disabled && this.showDragHandle(this.props.selected)}
        </span>
        {!_.isEmpty(this.props.memberCategories) && <div className="form-group">
          <br/>
          <Select
            multi={multi}
            name={"categories"}
            disabled={this.props.disabled}
            className={emptyClass}
            placeholder={'Velg kategori'}
            clearable={!this.props.teamCategory.require_member_category}
            value={value}
            onChange={(values) => {
              this.updateMultiSelect(values, 'categories');}}
            options={categoryOptions}
            />
        </div>}
        {ageText && <div className="alert alert-danger">{ageText}</div>}
        {this.props.diffStatus['changed'] && this.props.memberDiff && <p className="help-text text-warning">
          Slettede kategorier: {this.renderCategoryDiff().deleted.join(', ')}
          <br />
          Nye kategorier: {this.renderCategoryDiff().added.join(', ')}
        </p>}
      </div>
    );
  }
}

TeamMember.propTypes = {
  list: PropTypes.array,
  member: PropTypes.object,
  allMemberCategories: PropTypes.array,
  usedMemberCategories: PropTypes.object,
  teamCategory: PropTypes.object,
  memberCategories: PropTypes.array,
  team: PropTypes.object,
  connectDragSource: PropTypes.func,
  connectDragPreview: PropTypes.func,
  selected: PropTypes.bool,
  selectedMembers: PropTypes.array,
  addToSelected: PropTypes.func,
  clearSelected: PropTypes.func,
  removeMemberRegFromTeam: PropTypes.func,
  updateTeamMember: PropTypes.func,
  memberDiff: PropTypes.object,
  diffStatus: PropTypes.object,
  disabled: PropTypes.bool,
};

export default DragSource('MEMBER', memberSource, collect)(TeamMember);



/** WEBPACK FOOTER **
 ** ./src/containers/events/register/TeamMember.js
 **/